import React from 'react';
import SvgIcon from '../../Components/Icons/SvgIcon';
import MapMarker from '../../Components/Icons/MapMarker';
import {IGenericObject} from '../../Foundations/Types/IGenericObject';

interface IProps {
    className?: string;
    lat: number;
    lng: number;
    height: number;
    width: number;
    onClick?(): void;
}

const CircleMapMarker: React.FC<IProps> = ({ width, height, className, onClick }) => {
    // ensure it in the center of coordinate
    const mainElementStyle: IGenericObject = {
        width: `${width}px`,
        height: `${height}px`,
        left: `-${width/2}px`,
        top: `-${height/2}px`
    }

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        if (typeof onClick !== 'undefined') {
            onClick();
        }
    }

    return (
        <div style={mainElementStyle}
             onClick={handleClick}
             className={`absolute rounded-full flex justify-center items-center ${typeof className === 'string' ? className : ''}`}
        >
           <SvgIcon className="fill-white">
               <MapMarker />
           </SvgIcon>
        </div>
    )
}

export default CircleMapMarker;
